import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { SectionHeading, Reveal, EASE } from "@/components/Reveal";

const FAQS = [
  {
    q: "What contract models does NGCONDE offer to logistics companies?",
    a: "We operate primarily on dedicated monthly vehicle contracts, scheduled daily route subcontracting, and peak season overflow agreements with predefined service level targets.",
  },
  {
    q: "Do you provide proof of delivery (POD) documentation?",
    a: "Yes. Digital POD capture and real-time dispatch updates are standard protocol on every contracted delivery manifest.",
  },
  {
    q: "Can you provide subcontract capacity for established courier networks?",
    a: "Yes. We frequently act as dedicated outsourced wheels for national courier firms needing dependable last-mile or regional branch overflow capacity.",
  },
  {
    q: "What vehicles are currently deployed in your fleet?",
    a: "Our core operations deploy light delivery bakkies (open dropside and canopy enclosed) suited for parcel cages, palletised cargo and retail distribution runs.",
  },
  {
    q: "How quickly can contract operations commence?",
    a: "Upon agreement of scope and route SLA verification, dedicated vehicles can be assigned to scheduled runs within 48 to 72 hours.",
  },
];

export const Faq = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 py-20 md:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="Procurement FAQ"
              title="Answers before the site visit."
              intro="The questions logistics managers and procurement teams ask us most."
            />
          </div>

          <div className="lg:col-span-8">
            <Reveal>
              <div className="border-t border-white/10">
                {FAQS.map((f, i) => {
                  const open = openIdx === i;
                  return (
                    <div key={f.q} className="border-b border-white/10">
                      <button
                        onClick={() => setOpenIdx(open ? -1 : i)}
                        data-testid={`faq-item-${i + 1}`}
                        aria-expanded={open}
                        className="flex w-full items-center justify-between gap-4 py-5 text-left md:py-6"
                      >
                        <span
                          className={`font-display text-base font-bold tracking-tight transition-colors md:text-xl ${
                            open ? "text-[#FF6B00]" : "text-white"
                          }`}
                        >
                          {f.q}
                        </span>
                        <Plus
                          className={`h-5 w-5 shrink-0 transition-transform duration-300 ${
                            open ? "rotate-45 text-[#FF6B00]" : "text-slate-500"
                          }`}
                        />
                      </button>
                      <AnimatePresence initial={false}>
                        {open && (
                          <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.3, ease: EASE }}
                            className="overflow-hidden"
                          >
                            <p className="max-w-2xl pb-6 text-sm leading-relaxed text-slate-300 md:text-base">
                              {f.a}
                            </p>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  );
                })}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
